import type { AppDispatch } from "_shared/_stores/store-types";
import EntityMember from "_shared/entity-members/entity-member";
import Guid from "_shared/guids/guid";
import type { NavigateFunction } from "react-router";
import type Session from "users/__session/session";
import ProposalBuilder from "work/proposals/__builder/proposal-builder";
import {
  replaceOriginalProposalBuilder,
  replaceUpdatedProposalBuilder,
} from "work/proposals/_store/proposals-redux-slice";
import { PageTab } from "work/proposals/_views/drafts/draft-proposal-page-tabs";
import VendorTeam from "work/work-agreements/teams/vendor-team/vendor-team";

type StartDraftProposalWithVendorTeamLeaderArgs = {
  dispatch: AppDispatch;
  leader: {
    legalEntityId: Guid;
    userId: Guid;
  };
  navigate: NavigateFunction;
  session: Session;
};

export default function startDraftProposalWithVendorTeamLeader(
  args: StartDraftProposalWithVendorTeamLeaderArgs,
) {
  const { dispatch, leader, navigate, session } = args;
  const leaderMember = new EntityMember(leader);
  const builder = session.context?.viewingAsVendor
    ? new ProposalBuilder({ session }).setClient(leaderMember)
    : new ProposalBuilder({ session }).setVendorTeam(
        new VendorTeam({
          leader: leaderMember,
          members: [],
        }),
      );

  dispatch(replaceOriginalProposalBuilder({ proposalId: Guid.EMPTY, builder }));
  dispatch(replaceUpdatedProposalBuilder({ proposalId: Guid.EMPTY, builder }));
  navigate(`/proposals/drafts/create/${PageTab.VendorTeam}`);
}
